import React, { memo } from 'react';

import { Icon, Popover, Text, Spacer } from '@Sage/hoi-poi-ui';

import { getLiteral } from 'utils/getLiteral';

const WarningPopoverIcon = memo(function WarningPopoverIcon() {
    return (
        <Popover
            content={
                <div>
                    <Text type="subtitle" bold>
                        {getLiteral('label_warning_inactive_unit_measure')}
                    </Text>
                    <Spacer y={2} />
                    <Text>{getLiteral('label_warning_inactive_unit_measure_desc')}</Text>
                </div>
            }
            placement="top"
            trigger={['hover', 'click']}
        >
            <span
                className="fm-uom-cell__warning-popover-trigger"
                onMouseDown={(event) => event.stopPropagation()}
            >
                <span className="fm-uom-cell__option-warning">
                    <Icon name="warningOutline" />
                </span>
            </span>
        </Popover>
    );
});

export default WarningPopoverIcon;
